<template>
  <button
    class="back-link"
    @click="navigate"
  >
    <ChevronIcon class="back-link__icon"/>
    <span class="back-link__text">
      {{ text }}
    </span>
  </button>
</template>

<script>
  import { mapState } from 'vuex'
  import ChevronIcon from '@/assets/img/icons/chevron.svg?inline'
  import { DEFAULT_LANG } from '@/helpers/constant'

  export default {
    name: 'BackLink',
    components: {
      ChevronIcon
    },
    props: {
      text: {
        type: String,
        required: true
      },
      to: {
        type: [String, Object],
        default: ''
      }
    },
    computed: {
      ...mapState(['route'])
    },
    methods: {
      navigate () {
        const lang = this.$store.state.currentLang
        const queryLang = lang !== DEFAULT_LANG ? `lang=${lang}` : ''

        const to = !this.to
          ? this.route.from.fullPath
          : this.to
        if (typeof to === 'string') {
          const hasQuery = to.includes('?')
          const hasLang = to.includes('lang=')

          if (hasLang) {
            this.$router.push(to)
          } else {
            const separator = hasQuery ? '&' : '?'
            this.$router.push(`${to}${separator}${queryLang}`)
          }

          return
        } else if (typeof to === 'object') {
          const newTo = { ...to }
          if (!newTo.query) {
            newTo.query = {}
          }
          this.$router.push(newTo)
          return
        }
        this.$router.push(to)
      }
    }
  }
</script>

<style lang="scss">
.back-link {
  position: absolute;
  top: 0;
  left: -4px;
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
  text-decoration: none;
  cursor: pointer;
  background: none;
  border: none;
  outline: none;

  @include mobile {
    margin-left: 15px;
  }

  &__icon {
    width: 15px;
    height: 15px;
    stroke: $c-black;
    transition: stroke 0.3s;
    transform: translateY(1px);
  }

  &__text {
    padding-left: 10px;
    font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
    font-size: 14px;
    color: $c-black;
    transition: color 0.3s;
  }

  @include hover {
    .back-link__icon {
      stroke: $c-active;
    }

    .back-link__text {
      color: $c-active;
    }
  }

  &:focus {
    .back-link__icon {
      stroke: $c-active;
    }

    .back-link__text {
      color: $c-active;
    }
  }
}
</style>
